export function createPreviewSplits(standard: number) {
  return { standard, landscape: 70 }
}

export function updatePreviewSplit(
  splits: ReturnType<typeof createPreviewSplits>,
  landscape: boolean,
  percent: number
) {
  return {
    splits: { ...splits, [landscape ? 'landscape' : 'standard']: percent },
    persistPercent: landscape ? null : percent,
  }
}
